import { gql } from '@apollo/client';
export const StatPermissionsRatioInfo = gql `
    query StatPermissionsRatioInfo($siteSetId: SiteSetId!, $calculationConfig: RatioCalculationConfigInput) {
        staffhours {
            management {
                ratioInfo(siteSetId: $siteSetId, calculationConfig: $calculationConfig) {
                    canViewChildrenAttending
                    canViewStaffAttending
                    canViewChildrenExpected
                    canViewStaffExpected
                    canViewRatioInfo
                    canViewCareRulesSummary
                }
            }
        }
    }
`;
